/** 兜底：接口未返回 expireAt 时，与 order.pay.timeout.hours 默认 1 小时一致 */
export const CASHIER_PAY_VALID_MINUTES = 60;

const API_TIME_RE = /^(\d{4})-(\d{2})-(\d{2}) (\d{2}):(\d{2}):(\d{2})$/;

/** buyer-web ApiUtil 会把 yyyy-MM-dd HH:mm:ss 转成 Date，收银台需兼容 */
export function coerceCashierDateTimeText(raw: unknown): string {
  if (raw == null) {
    return "";
  }
  if (raw instanceof Date) {
    if (Number.isNaN(raw.getTime())) {
      return "";
    }
    const pad = (n: number) => String(n).padStart(2, "0");
    return (
      `${raw.getFullYear()}-${pad(raw.getMonth() + 1)}-${pad(raw.getDate())} ` +
      `${pad(raw.getHours())}:${pad(raw.getMinutes())}:${pad(raw.getSeconds())}`
    );
  }
  if (typeof raw === "string") {
    return raw;
  }
  return String(raw);
}

export function parseApiDateTime(
  raw: string | Date | null | undefined
): Date | null {
  if (raw instanceof Date) {
    return Number.isNaN(raw.getTime()) ? null : raw;
  }
  if (raw == null) {
    return null;
  }
  const s = coerceCashierDateTimeText(raw).trim();
  if (!s) {
    return null;
  }
  const m = API_TIME_RE.exec(s);
  if (!m) {
    return null;
  }
  const d = new Date(
    Number(m[1]),
    Number(m[2]) - 1,
    Number(m[3]),
    Number(m[4]),
    Number(m[5]),
    Number(m[6])
  );
  return Number.isNaN(d.getTime()) ? null : d;
}

/** 2026-07-09 12:31:32 → 2026年07月09日 12:31:32 */
export function formatCashierOrderTime(
  raw: string | Date | null | undefined
): string {
  const text = coerceCashierDateTimeText(raw).trim();
  if (!text) {
    return "—";
  }
  const d = parseApiDateTime(text);
  if (!d) {
    return text;
  }
  const pad = (n: number) => String(n).padStart(2, "0");
  return (
    `${d.getFullYear()}年${pad(d.getMonth() + 1)}月${pad(d.getDate())}日 ` +
    `${pad(d.getHours())}:${pad(d.getMinutes())}:${pad(d.getSeconds())}`
  );
}

export function resolvePayDeadlineMs(
  createdAt?: string | Date | null,
  expireAt?: string | Date | null
): number | null {
  const expire = parseApiDateTime(expireAt);
  if (expire) {
    return expire.getTime();
  }
  const created = parseApiDateTime(createdAt);
  if (!created) {
    return null;
  }
  return created.getTime() + CASHIER_PAY_VALID_MINUTES * 60 * 1000;
}

export function formatCountdown(remainingMs: number): string {
  const totalSec = Math.max(0, Math.ceil(remainingMs / 1000));
  const h = Math.floor(totalSec / 3600);
  const m = Math.floor((totalSec % 3600) / 60);
  const s = totalSec % 60;
  const pad = (n: number) => String(n).padStart(2, "0");
  if (h > 0) {
    return `${pad(h)}:${pad(m)}:${pad(s)}`;
  }
  return `${pad(m)}:${pad(s)}`;
}
